import { CSSProperties, FC, ReactNode } from 'react';
type Iprops = {
  heading: string;
  rightSideComponent?: ReactNode;
  style?: CSSProperties;
  onClick?: () => void;
};
const BlockHeading: FC<Iprops> = ({
  heading,
  rightSideComponent,
  style = {},
  onClick,
}: Iprops) => {
  return (
    <div
      onClick={() => {
        typeof onClick === 'function' && onClick();
      }}
      className="font-semibold my-4 py-2 flex items-center"
      style={{
        color: 'var(--black-primary)',
        cursor: typeof onClick === 'function' ? 'pointer' : '',
        fontSize: '1.2rem',
        ...style,
      }}
    >
      {heading}
      {rightSideComponent && (
        <div style={{ marginLeft: 'auto' }}>{rightSideComponent}</div>
      )}
    </div>
  );
};
export default BlockHeading;
